import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.keys.js";
import draggable from "vuedraggable";
import ColorPicker from "@/pages/design/components/ColorPicker";
import Card from "@/pages/design/components/Card";
import CardItem from "@/pages/design/components/CardItem";
import InputBar from "@/pages/design/components/InputBar";
import { upload } from "@/services/common";
import FormEditPage from "@/pages/design/components/FormEditPage";
import Title from "@/pages/design/components/Title";
import FileUpload from '@/pages/design/components/FileUpload';
import { mapState } from 'vuex';
export default {
  i18n: require('../../design_i18n'),
  components: {
    ColorPicker: ColorPicker,
    Card: Card,
    CardItem: CardItem,
    InputBar: InputBar,
    FormEditPage: FormEditPage,
    Title: Title,
    FileUpload: FileUpload,
    draggable: draggable
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      form: this.$form.createForm(this),
      defaultLangId: 0,
      curInfoItem: 0,
      // 当前 custominfo的索引
      curLinkItem: 0,
      // 当前 编辑自定义链接的索引
      showEditLogo: false,
      // 开关 编辑logo区域
      showEditText: false,
      // 开关 编辑logo区域的文本
      showEditLink: false,
      // 开关 编辑自定义链接的配置页面
      showEditLink_link: false,
      // 开关  编辑自定义链接的自定义链接的配置页面
      showEditIcon: false,
      // 开关 编辑logo区域的媒体icon
      activeKey: []
    };
  },
  created: function created() {
    var defaultLangObjStr = window.localStorage.cdefaultLangObj ? window.localStorage.cdefaultLangObj : window.localStorage.defaultLangObj;
    var defaultLangObj = JSON.parse(defaultLangObjStr);
    // let defaultLangObj = JSON.parse(localStorage.defaultLangObj);
    if (defaultLangObj) {
      this.defaultLangId = defaultLangObj.langId;
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    imgHost: function imgHost(state) {
      return state.design.imgHost;
    }
  })), {}, {
    logoList: function logoList() {
      if (!this.value.custominfo[this.curInfoItem].logoPath) return [];
      return [this.imgHost + this.value.custominfo[this.curInfoItem].logoPath];
    },
    wxmpList: function wxmpList() {
      // TODO wx 上传图片的 list
      return function (i) {
        if (!this.value.custominfo[this.curInfoItem].shareIcon[i].content) return [];
        return [this.imgHost + this.value.custominfo[this.curInfoItem].shareIcon[i].content];
      };
    },
    // 社交媒体图标
    iconList: function iconList() {
      return function (i) {
        if (!this.value.custominfo[this.curInfoItem].shareIcon[i].icon_link) return [];
        return [this.imgHost + this.value.custominfo[this.curInfoItem].shareIcon[i].icon_link];
      };
    }
  }),
  methods: {
    handleDeleteLinkByIndex: function handleDeleteLinkByIndex(i) {
      this.value.custominfo[this.curInfoItem].content.splice(i, 1);
      this.curLinkItem = 0;
    },
    handleDeleteLink: function handleDeleteLink() {
      this.value.custominfo[this.curInfoItem].content.splice(this.curLinkItem, 1);
      this.curLinkItem = 0;
      this.showEditLink_link = false;
    },
    handleLogoDelete: function handleLogoDelete() {
      this.value.custominfo[this.curInfoItem].logoPath = '';
    },
    handleLogoUploadSuccess: function handleLogoUploadSuccess(val, item) {
      item.logoPath = val;
    },
    handleIconUploadSuccess: function handleIconUploadSuccess(val, item, i) {
      item.content = val;
    },
    /**
     * 社交媒体icon上传成功
     * @param val
     * @param item
     * @param i
     */
    handleUploadSuccess: function handleUploadSuccess(val, item, i) {
      item.icon_link = val;
    },
    handleListLinkClick: function handleListLinkClick(item, i) {
      this.curLinkItem = i;
      this.showEditLink_link = true;
    },
    handleAddLinkClick: function handleAddLinkClick() {
      this.value.custominfo[this.curInfoItem].content.push({
        title: {},
        link: ''
      });
      this.curLinkItem = this.value.custominfo[this.curInfoItem].content.length - 1;
      this.showEditLink_link = true;
    },
    handleListItemClick: function handleListItemClick(item, i) {
      this.curInfoItem = i;
      if (item.type === 0) {
        this.showEditLogo = true;
      } else if (item.type === 1) {
        this.showEditLink = true;
      }
    },
    handleMenuDelete: function handleMenuDelete(i) {
      this.value.custominfo.splice(i, 1);
      this.curInfoItem = 0;
    },
    handleMenuClick: function handleMenuClick(v) {
      if (v.key == "0") {
        this.value.custominfo.push({
          type: 0,
          logoPath: "",
          logoWidth: 200,
          subContent: {},
          textFontSize: 12,
          textFontColor: "#e1e1e1",
          textActFontColor: "#B4A172",
          shareIcon: [{
            name: "Twitter",
            type: 0,
            content: "",
            status: false,
            icon_link: "",
            icon_size: 32,
            content_link: ""
          }, {
            name: "Facebook",
            type: 0,
            content: "",
            status: false,
            icon_link: "",
            icon_size: 32,
            content_link: ""
          }, {
            name: "公众号",
            type: 1,
            content: "",
            status: false,
            icon_link: "",
            icon_size: 32,
            content_link: ""
          }, {
            name: "Line",
            type: 1,
            content: "",
            status: false,
            icon_link: "",
            icon_size: 32,
            content_link: ""
          }, {
            name: "Weibo",
            type: 0,
            content: "",
            status: false,
            icon_link: "",
            icon_size: 32,
            content_link: ""
          }, {
            name: "Instagram",
            type: 0,
            content: "",
            status: false,
            icon_link: "",
            icon_size: 32,
            content_link: ""
          }, {
            name: "Tumblr",
            type: 0,
            content: "",
            status: false,
            icon_link: "",
            icon_size: 32,
            content_link: ""
          }, {
            name: "Snapchat",
            type: 0,
            content: "",
            status: false,
            icon_link: "",
            icon_size: 32,
            content_link: ""
          }, {
            name: "YouTube",
            type: 0,
            content: "",
            status: false,
            icon_link: "",
            icon_size: 32,
            content_link: ""
          }, {
            name: "Vimeo",
            type: 0,
            content: "",
            status: false,
            icon_link: "",
            icon_size: 32,
            content_link: ""
          }, {
            name: "Pinterest",
            type: 0,
            content: "",
            status: false,
            icon_link: "",
            icon_size: 32,
            content_link: ""
          }, {
            name: "App Store",
            type: 0,
            content: "",
            status: false,
            icon_link: "",
            icon_size: 32,
            content_link: ""
          }, {
            name: "Google Play",
            type: 0,
            content: "",
            status: false,
            icon_link: "",
            icon_size: 32,
            content_link: ""
          }],
          iconFontSize: 32,
          shareIconMarignRight: 0,
          shareIconMarignBottom: 0
        });
        this.curInfoItem = this.value.custominfo.length - 1;
        this.showEditLogo = true;
      } else if (v.key === "1") {
        var langList = localStorage.langList;
        var obj = {};
        if (langList) {
          langList = JSON.parse(langList);
          var _iterator = _createForOfIteratorHelper(langList),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              obj[item.langId] = '菜单标题';
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        this.value.custominfo.push({
          type: 1,
          title: obj,
          titleFontSize: 18,
          titleColor: "#1e1e1e",
          titleSubColor: "#ae9a69",
          content: [],
          textFontSize: 13,
          textFontColor: "#1e1e1e",
          hoverTextFontColor: "#ae9a69"
        });
        this.curInfoItem = this.value.custominfo.length - 1;
        this.showEditLink = true;
      }
    }
  }
};